export enum HomeTabs {
  Undefined = 'Undefined',
  Forms = 'Forms',
  Equipments = 'Equipments',
  Declarations = 'Declarations',
  Inboxes = 'Inboxes',
  QrScan = 'QrScan',
}
